import { render } from "./CardExhibition.vue?vue&type=template&id=1fc0ebf6"
import script from "./CardExhibition.vue?vue&type=script&lang=js"
export * from "./CardExhibition.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__